import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {NgForOf, NgIf} from "@angular/common";
import {MatIconModule} from "@angular/material/icon";
export interface ActionCallback {
  callback: () => void;
  default: boolean;
}
interface IconActionBar{
  name: string,
  onIcon: string,
  offIcon: string,
  tooltip?: string;
  isActive?: boolean;
  order?: number;
  callback?: Function
}
@Component({
  selector: 'app-action-bar-button',
  templateUrl: './action-bar-button.component.html',
  standalone: true,
  imports: [
    NgIf,
    NgForOf,
    MatIconModule
  ],
  styleUrls: ['./action-bar-button.component.scss']
})
export class ActionBarButtonComponent implements OnChanges {
  // Parent provides callbacks for actions they want to enable
  @Input() actionCallbacks = {};

  // All possible actions (defined internally)
  private iconsList: IconActionBar[] = [
    {
      name: "filter",
      onIcon: "filter_alt",
      offIcon: "filter_alt_off",
      tooltip: "Toggle filter",
      isActive: false
    },
    {
      name: "sort",
      onIcon: "arrow_upward",
      offIcon: "arrow_downward",
      tooltip: "Toggle sort",
      isActive: false
    }
  ];

  actionsToShow: IconActionBar[] = [];
  isOpen = false;

  ngOnChanges(changes: SimpleChanges) {
    // Automatically enable actions with provided callbacks
    this.actionsToShow = this.iconsList
        .filter(action => this.actionCallbacks.hasOwnProperty(action.name))
        .map(action => ({
          ...action,
          callback: this.actionCallbacks[action.name].callback,
          isActive: this.actionCallbacks[action.name].callback == null ? action.isActive: this.actionCallbacks[action.name].callback,
        })).sort((a: IconActionBar, b: IconActionBar) => a.order - b.order);
  }

  toggleBar() {
    this.isOpen = !this.isOpen;
  }

  handleAction(action: IconActionBar) {
    if (action.isActive !== undefined) {
      action.isActive = !action.isActive;
    }
    if (action.callback) {
      action.callback(action.isActive);
    }
  }
}

